export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              随时随地
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              嫩草视频移动端已适配手机与平板设备，无论你在通勤路上、午休间隙还是旅途中，打开浏览器即可畅享高清影视内容。无需下载App，不占手机存储空间，极速加载、自适应画质，让观影随时随地。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机浏览器打开
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:bg-foreground-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多功能
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-100">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">iOS Safari 完美适配</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-100">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">Android Chrome 流畅运行</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-100">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">平板大屏自动适配</span>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full max-w-sm">
            <div className="relative mx-auto w-[240px]">
              <div className="aspect-[9/16] rounded-[2.5rem] border-4 border-foreground-900 overflow-hidden bg-foreground-950 shadow-2xl">
                <div className="h-8 bg-foreground-900 flex items-center justify-center rounded-t-[2rem]">
                  <div className="w-16 h-1.5 rounded-full bg-foreground-700"></div>
                </div>
                <div className="p-4 pt-2">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-6 h-6 rounded-md bg-primary-500 flex items-center justify-center">
                      <i className="ri-movie-line text-background-50 text-xs"></i>
                    </div>
                    <span className="text-xs font-medium text-background-50">嫩草视频</span>
                  </div>
                  <div className="space-y-3">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="flex items-center gap-3 p-2 rounded-lg bg-foreground-800/50">
                        <div className={`w-10 h-14 rounded-md flex-shrink-0 ${
                          i === 1 ? 'bg-primary-600/40' :
                          i === 2 ? 'bg-accent-600/40' :
                          i === 3 ? 'bg-secondary-500/40' :
                          'bg-foreground-600/40'
                        }`}></div>
                        <div className="flex-1 min-w-0">
                          <div className="h-2.5 rounded-full bg-foreground-600/60 w-3/4 mb-1.5"></div>
                          <div className="h-2 rounded-full bg-foreground-600/40 w-1/2"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary-500/20 rounded-3xl -z-10"></div>
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-accent-500/20 rounded-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}